/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { Card } from '@/components/ui/card';
import { StoreFilter } from '@/components/StoreFilter';
import { ShoppingCart, LayoutTemplate, Settings2, Store as StoreIcon } from 'lucide-react';
import { StatsBar } from './recovery/StatsBar';
import { CartsPanel } from './recovery/CartsPanel';
import { TemplatesPanel } from './recovery/TemplatesPanel';
import { SettingsPanel } from './recovery/SettingsPanel';

export default function Recovery() {
  const [stores, setStores] = useState([]);
  const [storeId, setStoreId] = useState('');
  const [configured, setConfigured] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    api.get('/stores').then((r) => {
      setStores(r.data);
      if (r.data.length && !storeId) setStoreId(r.data[0].id);
    }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const loadTemplates = () => {
    if (!storeId) return setTemplates([]);
    api.get('/recovery/templates', { params: { store_id: storeId } }).then((r) => setTemplates(r.data)).catch(() => {});
  };
  useEffect(loadTemplates, [storeId, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    api.get('/recovery/stats', { params: storeId ? { store_id: storeId } : {} })
      .then((r) => setConfigured(r.data.email_configured)).catch(() => {});
  }, [storeId, refreshKey]);

  const bump = () => setRefreshKey((k) => k + 1);
  const storeName = stores.find((x) => x.id === storeId)?.name || '';
  const needStore = !storeId;

  return (
    <div className="p-4 sm:p-6 lg:p-10 max-w-7xl" data-testid="recovery-page">
      <div className="mb-6 flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="overline mb-2">— Hub de récupération</div>
          <h1 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">Relances paniers</h1>
          <p className="text-zinc-600 mt-2">Paramétrez, prévisualisez et lancez vos relances de paniers abandonnés.</p>
        </div>
        <StoreFilter stores={stores} value={storeId} onChange={setStoreId} allLabel="— Choisir —" testId="recovery-store-filter" />
      </div>

      <StatsBar storeId={storeId} refreshKey={refreshKey} />

      <Tabs defaultValue="carts" className="mt-2">
        <TabsList data-testid="recovery-tabs">
          <TabsTrigger value="carts" data-testid="tab-carts"><ShoppingCart className="h-4 w-4 mr-1.5" /> Paniers</TabsTrigger>
          <TabsTrigger value="templates" data-testid="tab-templates"><LayoutTemplate className="h-4 w-4 mr-1.5" /> Templates</TabsTrigger>
          <TabsTrigger value="settings" data-testid="tab-settings"><Settings2 className="h-4 w-4 mr-1.5" /> Paramètres</TabsTrigger>
        </TabsList>

        <TabsContent value="carts" className="mt-6">
          <CartsPanel storeId={storeId} configured={configured} templates={templates} onChanged={bump} />
        </TabsContent>

        <TabsContent value="templates" className="mt-6">
          {needStore ? <PickStore /> : <TemplatesPanel storeId={storeId} storeName={storeName} onChanged={bump} />}
        </TabsContent>

        <TabsContent value="settings" className="mt-6">
          {needStore ? <PickStore /> : <SettingsPanel storeId={storeId} templates={templates} onChanged={bump} />}
        </TabsContent>
      </Tabs>
    </div>
  );
}

const PickStore = () => (
  <Card className="p-10 text-center text-zinc-400" data-testid="pick-store-prompt">
    <StoreIcon className="h-8 w-8 mx-auto mb-2 opacity-40" />
    Sélectionnez une boutique pour configurer ses templates et paramètres.
  </Card>
);
